import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { RestResponse as GenericRestResponse } from 'app/modules/common/entities/rest.response.generic.model';
import { Observable } from 'rxjs/internal/Observable';
import { ApiService } from '../../common/services/api.service';
import API from '../../common/services/api.config.json';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { DownloadableDocument } from 'app/modules/common/entities/dropdown/downloadable-document.model';

@Injectable({
    providedIn: 'root'
})
export class SendingService {

    public selectedCompanyId = null;

    constructor(
        private apiService: ApiService,
        public empresaTreeViewService: EmpresaTreeViewService) {
        this.getSelectedCompany();
    }

    private getSelectedCompany(): void {
        this.empresaTreeViewService.EmpId.subscribe((_res: any) => {
            this.selectedCompanyId = _res;
        });
    }

    administrativeUsers(): Observable<RestResponse> {
        const url = `${API.Sendings.administrativeUsers}`;
        return this.apiService.get(url);
    }

    getAllMedicos(): Observable<RestResponse> {
        const url = `${API.Sendings.getAllMedicos}`;
        return this.apiService.get(url);
    }

    Tareas(tareas: any): Observable<RestResponse> {
        const url = `${API.Sendings.tareas}`;
        console.log(tareas);
        return this.apiService.post(url, tareas);
    }

    NotificationTareasEliminadas(taskDeletionNotification: any): Observable<RestResponse> {
        const url = `${API.Sendings.notificationTareasEliminadas}`;
        return this.apiService.post(url, taskDeletionNotification);
    }

    Listados(reports: any): Observable<RestResponse> {
        const url = `${API.Sendings.listados}`;
        return this.apiService.post(url, reports);
    }

    Altas(discharges: any): Observable<RestResponse> {
        const url = `${API.Sendings.altas}`;
        return this.apiService.post(url, discharges);
    }

    SolicitudesDeAltas(company: any): Observable<RestResponse> {
        const url = API.Sendings.solicitudesDeAltas as string;
        return this.apiService.post(url, company);
    }

    SolicitudesDeDireccion(company: any): Observable<RestResponse> {
        const url = `${API.Sendings.solicitudesDeDireccion}` as string;
        return this.apiService.post(url, company);
    }

    SolicitudesDePlantilla(company: any): Observable<RestResponse> {
        const url = `${API.Sendings.solicitudesDePlantilla}` as string;
        return this.apiService.post(url, company);
    }


    /**
     * Get citation zip file
     * @param empresaId Company ID
     */
    getGetCitationZip(company)
        : Observable<GenericRestResponse<{
            zipFile: DownloadableDocument;
            bajasIds: number[];
            tareasIds: number[];
        }>> {

        // build URL
        const url = API.Sendings.getGetCitationZip 
        // call API
        console.log(company)
        return this.apiService.post(url,company);

    }


    /**
     * Clean task and leaves after downloading citation
     */
    cleanAfterCitation(bajasIds: number[], tareasIds: number[]): Observable<GenericRestResponse<null>> {

        // build URL
        const url = API.Sendings.cleanAfterCitation as string;
        // call API
        return this.apiService.post(url, { bajasIds, tareasIds });

    }

}


